/**
 * ---------------------------------------------------------------------------
 * Vue Router Configuration (Shell Application)
 * ---------------------------------------------------------------------------
 * This file defines the complete routing setup for the Vue 3 shell application.
 *
 * The shell hosts multiple Micro Frontends (MFEs) and shared preview pages.
 * It also handles reserved paths for embedded MFEs, application dashboards,
 * and fallback pages such as "Unavailable" and "Not Found".
 *
 * @author: Harvinder Singh <harvinder@maropost.com>
 * @created: 2025-09-12
 * ---------------------------------------------------------------------------
 */

import { createRouter, createWebHistory } from "vue-router"
import routes from "./routeList"



// -----------------------------------------------------------------------------
// Router Instance
// -----------------------------------------------------------------------------
// Using HTML5 history mode for clean URLs (no #hash).
// The base "/" ensures proper linking and navigation under root deployment.
const router = createRouter({
  history: createWebHistory("/"),
  routes,
})

// -----------------------------------------------------------------------------
// Global Navigation Guards
// -----------------------------------------------------------------------------
router.beforeEach(async (to, _from, next) => {

  next()
})

// -----------------------------------------------------------------------------
// Export Router
// -----------------------------------------------------------------------------
export default router
